export default (function () {
  return {};
});
//# sourceMappingURL=layoutVariables.js.map
